import styles from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';

export default function WeatherResistant() {
    const { useLang } = useGlobal();
    const { t } = useLang('PoweroceanSinglePhase.WeatherResistant');
    return (
        <div className={`${styles.weatherResistant}`}>
            <div className="container">
                <div className="bg-img">
                    <NextImage src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713524247497/Certified-tuya.jpg" alt={t('title')} />
                </div>

                <div className="bg-img-h5">
                    <NextImage src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713524240590/Certifiedmb-tuya.jpg" alt={t('title')} />
                </div>
                <div className="right-box">
                    <div className="text-box">
                        <div className="sub-title">{t('label')}</div>
                        <h2 className="title">{t('title')}</h2>
                        <div className="desc">{t('desc')}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
